export const categories = [
  {
    id: 1,
    name: "明星八卦",
    slug: "celebrity-gossip",
    description: "追踪娱乐圈最新动态，深扒明星八卦内幕。从恋情曝光到婚姻危机，从红毯翻车到人设崩塌，为您呈现娱乐圈最真实的另一面。",
    icon: "ri-star-line",
    count: 1280,
    image: "https://readdy.ai/api/search-image?query=Celebrity%20paparazzi%20photography%20concept%2C%20camera%20flashes%20and%20red%20carpet%2C%20glamorous%20Hollywood%20vibe%2C%20golden%20spotlights%2C%20luxurious%20atmosphere%2C%20editorial%20fashion%20photography%20style%2C%20warm%20tones&width=600&height=400&seq=cat-celebrity&orientation=landscape"
  },
  {
    id: 2,
    name: "网红爆料",
    slug: "influencer-expose",
    description: "揭秘网红圈真实生态，曝光直播带货内幕。从MCN压榨到假货风波，从人设造假到数据注水，带你看见滤镜背后的真相。",
    icon: "ri-live-line",
    count: 960,
    image: "https://readdy.ai/api/search-image?query=Social%20media%20influencer%20filming%20content%20with%20ring%20light%20and%20smartphone%2C%20modern%20studio%20setup%2C%20behind%20the%20scenes%20of%20content%20creation%2C%20warm%20ambient%20lighting%2C%20lifestyle%20photography&width=600&height=400&seq=cat-influencer&orientation=landscape"
  },
  {
    id: 3,
    name: "社会热点",
    slug: "social-hot-topics",
    description: "聚焦社会热点事件，深度剖析现象背后的本质。从商业丑闻到公共事件，从消费陷阱到行业乱象，为您还原事件全貌。",
    icon: "ri-fire-line",
    count: 1560,
    image: "https://readdy.ai/api/search-image?query=Busy%20city%20street%20with%20crowds%20of%20people%2C%20urban%20life%20documentary%20style%2C%20warm%20sunset%20lighting%2C%20modern%20metropolis%2C%20news%20and%20media%20concept%2C%20bustling%20atmosphere&width=600&height=400&seq=cat-social&orientation=landscape"
  },
  {
    id: 4,
    name: "综艺吃瓜",
    slug: "variety-show-drama",
    description: "综艺节目幕后全揭秘，台前幕后的精彩故事。从导师冲突到选手八卦，从录制翻车到剪辑玄机，综艺圈的瓜都在这里。",
    icon: "ri-tv-line",
    count: 820,
    image: "https://readdy.ai/api/search-image?query=TV%20show%20stage%20with%20bright%20colorful%20lights%2C%20variety%20show%20production%20set%2C%20cameras%20and%20equipment%2C%20entertainment%20industry%2C%20vibrant%20atmosphere%2C%20behind%20the%20scenes&width=600&height=400&seq=cat-variety&orientation=landscape"
  }
];

export const getCategoryBySlug = (slug: string) => categories.find(c => c.slug === slug);